export const NAVBAR = [
	{
		id: 1,
		name: 'Explainer video',
		to: 'https://files.gitbook.com/v0/b/gitbook-x-prod.appspot.com/o/spaces%2FwN9gr7D53un73iG7LD9D%2Fuploads%2FuRwAZoYxy5f6vdqN34Fr%2Fatlas_demo_with_introaudio_music_speech_full.mp4?alt=media&token=3f269ef9-bdb2-4c53-9818-ee2df52af478',
		target: '_blank',
	},
];
